import Splide from '@splidejs/splide';

const EL = '.js-Tiles';

if (document.querySelector(EL)) {
  const slider = new Splide(EL, {
    autoWidth: true,
    pagination: true,
    arrows: true,
    gap: 10,
    omitEnd: true,
    focus: 0
  }).mount();
}
